import React from 'react';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <header className="header">
      <div className="header__left">
        <Link to="/" className="header__logo">
          Home
        </Link>
      </div>
      <div className="header__right">
        <nav className="header__menu">
          {/* <Link to="/scenario-a" className="header__menu-item">
            Scenario A
          </Link>
          <Link to="/scenario-b" className="header__menu-item">
            Scenario B
          </Link>
          <Link to="/scenario-c" className="header__menu-item">a
            Scenario C
          </Link> */}
          {/* <Link to="/scenario-builder" className="header__menu-item">
            Station Planner
          </Link> */}
          <a href="/html/Final_Presentation.html" className="header__menu-item">
            Full Report
          </a>
          <Link to="/about" className="header__menu-item">
            About
          </Link>
        </nav>
      </div>
    </header>
  );
}

export default Header;
